import calendario from "../../../images/iconCalendar.svg";
import relogio from "../../../images/iconTime.svg";
import hospital from "../../../images/iconHospital.svg";
import retangulo from "../../../images/iconRectangle.svg";
import vetorbotao from "../../../images/vectorButton.svg";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";

export function CardNotification({
  title,
  icon,
  children,
  color = "#CCCCCC",
  onClick,
}) {
  return (
    <Stack sx={{ width: "100%", height: "100%" }}>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          border: `1px solid ${color}`,
          p: 2,
          borderRadius: "6px 6px 0 0",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Nunito",
            fontSize: "22px",
            fontWeight: 500,
            lineHeight: " 30.01px",
            textAlign: "left",
            color: "rgba(6, 63, 94, 1)",
          }}
        >
          {title}
        </Typography>
        <IconButton
          style={{ background: "rgba(239, 245, 247, 1)", borderRadius: "12px" }}
        >
          {icon}
        </IconButton>
      </Stack>
      <Stack
        sx={{
          height: "100%",
          p: 2,
          border: `1px solid ${color}`,
          borderTop: "none",
        }}
      >
        {children}
      </Stack>
      <Stack
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        sx={{
          border: `1px solid ${color}`,
          p: 2,
          borderRadius: "0px 0px 6px 6px",
          borderTop: "none",
        }}
      >
        <Button
          onClick={onClick}
          size="small"
          variant="contained"
          endIcon={<img src={vetorbotao} alt="Icon" />}
          sx={{
            textTransform: "initial",
          }}
        >
          Acessar detalhes
        </Button>
      </Stack>
    </Stack>
  );
}

export function Content1({ data }) {
  return (
    <Stack sx={{ width: "100%", height: "100%", gap: 2, color: "#063F5E" }}>
      <Stack gap={2} flexDirection="row" flexWrap="wrap" alignItems="center">
        <Stack gap={1} flexDirection="row" alignItems="center">
          <img
            src={calendario}
            style={{ height: 24, width: 24 }}
            alt="icon-calendario"
          />
          <Typography>
            {dayjs(data.dataConsulta.split("T")[0]).format("DD/MM/YYYY")}
          </Typography>
        </Stack>
        <Stack gap={1} flexDirection="row" alignItems="center">
          <img
            src={relogio}
            style={{ height: 24, width: 24 }}
            alt="icon-relogio"
          />
          <Typography>{data.inicio}</Typography>
        </Stack>
      </Stack>
      <Stack>
        <Stack gap={1} flexDirection="row" alignItems="center">
          <img
            src={hospital}
            style={{ height: 24, width: 24 }}
            alt="icon-hospital"
          />
          <Typography>{data.estabelecimento.nome}</Typography>
        </Stack>
      </Stack>
      <Stack>
        <Stack gap={1} pl={1} flexDirection="row" alignItems="center">
          <img
            src={retangulo}
            style={{ height: 10, width: 10 }}
            alt="icon-retangulo"
          />
          <Typography>
            {data.participantes.length > 1
              ? "Multidisciplinar Presencial"
              : data.participantes.length === 1 &&
                data.participantes[0].perfil.descricao}{" "}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export function NoteIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      color="#1E729F"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8.5V18.25C20 21.25 18.21 22.25 16 22.25H8C5.79 22.25 4 21.25 4 18.25V8.5C4 5.25 5.79 4.5 8 4.5C8 5.12 8.24997 5.68 8.65997 6.09C9.06997 6.5 9.63 6.75 10.25 6.75H13.75C14.99 6.75 16 5.74 16 4.5C18.21 4.5 20 5.25 20 8.5Z"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 4.5C16 5.74 14.99 6.75 13.75 6.75H10.25C9.63 6.75 9.06997 6.5 8.65997 6.09C8.24997 5.68 8 5.12 8 4.5C8 3.26 9.01 2.25 10.25 2.25H13.75C14.37 2.25 14.93 2.5 15.34 2.91C15.75 3.32 16 3.88 16 4.5Z"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 13.25H12"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 17.25H16"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function DocumentIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.9163 13.6722V20.1305C28.9163 26.5889 26.333 29.1722 19.8747 29.1722H12.1247C5.66634 29.1722 3.08301 26.5889 3.08301 20.1305V12.3805C3.08301 5.9222 5.66634 3.33887 12.1247 3.33887H18.583"
        stroke="#1E729F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.9163 13.6722H23.7497C19.8747 13.6722 18.583 12.3805 18.583 8.50553V3.33887L28.9163 13.6722Z"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.54199 17.5479H17.292"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.54199 22.7139H14.7087"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function VacinaIcon() {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0305 5.51074H13.9705C13.1476 5.51074 12.4805 6.1756 12.4805 6.99574C12.4805 7.81589 13.1476 8.48074 13.9705 8.48074H18.0305C18.8534 8.48074 19.5205 7.81589 19.5205 6.99574C19.5205 6.1756 18.8534 5.51074 18.0305 5.51074Z"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M17.9201 10.9405H17.4601V8.48047H14.5401V10.9405H14.0801C13.6901 10.9405 13.3701 11.1905 13.3701 11.4905V24.9605C13.3701 26.0805 14.5501 27.0005 16.0001 27.0005C17.4501 27.0005 18.6301 26.0905 18.6301 24.9605V11.4905C18.6301 11.1905 18.3101 10.9405 17.9201 10.9405V10.9405Z"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M13.3701 15.9111H18.6301"
        stroke="#1E729F"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  );
}
